/* eslint-disable */

import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { CombinedReducersType } from "@type/index";
import { isEmpty } from "lodash";
import {
  Accordion,
  Checkbox,
  CheckboxGroup,
  CollectionList,
  Spacer,
  TagFilter,
  TagFilterGroup,
  Title,
  Dropdown,
  Body
} from "@common/AggregationComponent";
import {
  handleDuplicate,
  transformBrandForGoogleAnalytics
} from "@util/common";
import { sendTrackEvent, TRACK_EVENT_SEARCH } from "@util/gtm";
import { getEcRenewalCompatibility } from "@util/common";

enum TAG_TYPE {
  SIZE = "size",
  CATEGORY = "category"
}

const emptyListColumnCount = {
  lg: 1,
  md: 1,
  sm: 1
};
const nonEmptyListColumnCount = {
  lg: 2,
  md: 2,
  sm: 2
};
export interface FilterModelArgs {
  visible: boolean;
  total: number | string;
  tree: any;
  sizes: any[];
  visibleSize: boolean;
  visibleCategory: boolean;
  categoryType: string;
  selectedSizes: any[];
  filteredSizes: any[];
  selectedCategories: any[];
  searchCategories: any[];
  searchSizes: any[];
  onChangeSelectedSizes: (sizes: any[]) => void;
  onChangeSelectedCategories: (sizes: any[]) => void;
  handlerSizeExpand: () => void;
  handlerCategoryExpand: () => void;
  handlerClearAllFilter: () => void;
  setFilteredSizes: (size: any) => void;
  onClose: () => void;
  setIsClickSizeCheckList: any;
}

interface SelectedTagsType {
  filterSizes: any[];
  filtercategories: any[];
}

const ProductTabFilterDetails = (props: FilterModelArgs): any => {
  const {
    tree,
    sizes,
    visibleSize,
    visibleCategory,
    categoryType,
    selectedSizes,
    filteredSizes,
    selectedCategories,
    onChangeSelectedSizes,
    onChangeSelectedCategories,
    handlerSizeExpand,
    handlerCategoryExpand,
    handlerClearAllFilter,
    setFilteredSizes,
    setIsClickSizeCheckList
  } = props;
  const config = useSelector((state: CombinedReducersType) => state.app);
  const { t } = useTranslation();
  const [filteredCategories, setFilteredCategories] = useState<any[]>([]);
  const [isShowGenderSelect, setIsShowGenderSelect] = useState<boolean>(false);
  const [isShowClassSelect, setIsShowClassSelect] = useState<boolean>(false);
  const [isShowCategorySelect, setIsShowCategorySelect] =
    useState<boolean>(false);
  const [isShowSubcategorySelect, setIsShowSubcategorySelect] =
    useState<boolean>(false);

  const isEmptyList = !filteredSizes.filter((s) => s.display?.showFlag).length;

  const selectedTags = useMemo(
    (): SelectedTagsType => ({
      filterSizes: handleDuplicate(
        selectedSizes
          .map((size: any) => ({ ...size, type: TAG_TYPE.SIZE }))
          .sort(
            (sizeA: any, sizeB: any) => sizeA.displayCode - sizeB.displayCode
          ),
        "name"
      ),
      filtercategories: selectedCategories
        .map((size: any) => ({ ...size, type: TAG_TYPE.CATEGORY }))
        .sort((sizeA: any, sizeB: any) => sizeA.id - sizeB.id)
    }),
    [selectedSizes, selectedCategories, sizes.length]
  );

  const handleAddCategoryType = () => {
    const hasCategoryTypeTree: any = tree;
    const tempArr: any = [];
    const res: any = [];
    if (hasCategoryTypeTree?.genders?.length > 0) {
      hasCategoryTypeTree.genders.map((gender: any) => {
        tempArr.push({ ...gender, categoryType: "genders" });
      });
    }
    if (hasCategoryTypeTree?.classes?.length > 0) {
      hasCategoryTypeTree.classes.map((_class: any) => {
        tempArr.push({ ..._class, categoryType: "classes" });
      });
    }
    if (hasCategoryTypeTree?.categories?.length > 0) {
      hasCategoryTypeTree.categories.map((category: any) => {
        tempArr.push({ ...category, categoryType: "categories" });
      });
    }
    if (hasCategoryTypeTree?.subcategories?.length > 0) {
      hasCategoryTypeTree.subcategories.map((subcategory: any) => {
        tempArr.push({ ...subcategory, categoryType: "subcategories" });
      });
    }
    if (selectedCategories.length !== 0) {
      selectedCategories.map((itemOne: any) => {
        res.push(tempArr.find((itemTwo: any) => itemTwo.id === itemOne.id));
      });
    }
    return res;
  };

  const handlerCategoryClick = (value: any, type: string) => {
    const gaCatArr: any = selectedTags.filtercategories.map(
      (item) => item.name
    );
    const _index = handleAddCategoryType().findIndex(
      (item: any) => item.categoryType === type
    );
    if (value === "") {
      //if click "All" option
      if (_index !== -1) {
        //the option that user click is not the current choosen option
        const _res = JSON.parse(JSON.stringify(selectedCategories)).splice(
          0,
          _index
        );
        onChangeSelectedCategories(_res);
      }
    } else {
      if (
        selectedCategories.filter((item: any) => item.id === value).length === 0
      ) {
        //the option that user click is not the current choosen option
        if (_index !== -1) {
          //if this hierarchy has been choosen before
          const _newRes = {
            ...tree[type].find((_class: any) => _class.id === value),
            categoryType: type
          };
          const _res = JSON.parse(JSON.stringify(selectedCategories)).splice(
            0,
            _index
          );
          _res.push(_newRes);
          onChangeSelectedCategories(_res);
        } else {
          const res: any = filteredCategories.filter(
            (classOption: any) => classOption.id === value
          );
          onChangeSelectedCategories([...selectedCategories, ...res]);
        }
      }
    }
    //TODO: check this GA is right or not
    const sizesForGa = selectedTags.filterSizes.map((item) => item.name);
    const genderForGa = gaCatArr[0] || null;
    const categoryForGa = gaCatArr.slice(1).join(",") || null;
    sendTrackEvent({
      brand: transformBrandForGoogleAnalytics(config.brand_name),
      event: TRACK_EVENT_SEARCH,
      eventAction: "ImageItemSearch",
      eventCategory: "IS_Item_Filter",
      eventLabel: `${[...gaCatArr, ...sizesForGa].join(",")}`,
      genderFilter: genderForGa,
      categoryFilter: categoryForGa,
      sizeFilter: sizesForGa.join(",") || null
    });
  };
  const handlerDeleteTag = (tag: any) => {
    // cateegroy
    if (tag.type === TAG_TYPE.CATEGORY) {
      const selectedCategoryIndex = selectedCategories.findIndex(
        (category: any) => category.id === tag.id
      );
      const newCategories = JSON.parse(JSON.stringify(selectedCategories));
      if (selectedCategoryIndex > -1) {
        newCategories.splice(selectedCategoryIndex);
        onChangeSelectedCategories([...newCategories]);
      } else {
        onChangeSelectedCategories([...newCategories]);
      }
      const gaNewCategories = newCategories.map((item: any) => item.name);
      const sizesForGa = selectedTags.filterSizes.map((item) => item.name);
      const genderForGa = gaNewCategories[0] || null;
      const categoryForGa = gaNewCategories.slice(1).join(",") || null;
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(config.brand_name),
        event: TRACK_EVENT_SEARCH,
        eventAction: "ImageItemSearch",
        eventCategory: "IS_Item_Filter",
        eventLabel: `${[...gaNewCategories, ...sizesForGa].join(",")}`,
        genderFilter: genderForGa,
        categoryFilter: categoryForGa,
        sizeFilter: sizesForGa.join(",") || null
      });
    }
    if (tag.type === TAG_TYPE.SIZE) {
      // size
      const selectedSizeIndex = selectedSizes.findIndex(
        (size: any) => size.code === tag.code
      );
      const newSizes = JSON.parse(JSON.stringify(selectedSizes));
      if (selectedSizeIndex > -1) {
        const newSelectedSizes = selectedSizes;
        newSelectedSizes.splice(selectedSizeIndex, 1);
        onChangeSelectedSizes([...newSelectedSizes]);
      } else {
        onChangeSelectedSizes([...newSizes]);
      }
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize) => filteredSize.code === tag.code
      );
      const newFilterSizes = JSON.parse(JSON.stringify(filteredSizes));
      if (sizeIndex > -1) {
        const newFilteredSizes = filteredSizes;
        newFilteredSizes[sizeIndex].checked = false;
        setFilteredSizes([...newFilteredSizes]);
      } else {
        setFilteredSizes([...newFilterSizes]);
      }
      const sizesForGa = newSizes.map((item: any) => item.name);
      const catAndGenArr = selectedTags.filtercategories.map(
        (item) => item.name
      );
      const genderForGa = catAndGenArr[0] || null;
      const categoryForGa = catAndGenArr.slice(1).join(",") || null;
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(config.brand_name),
        event: TRACK_EVENT_SEARCH,
        eventAction: "ImageItemSearch",
        eventCategory: "IS_Item_Filter",
        eventLabel: `${[...catAndGenArr, ...sizesForGa].join(",")}`,
        genderFilter: genderForGa,
        categoryFilter: categoryForGa,
        sizeFilter: sizesForGa
      });
    }
  };
  const handlerSizeClick = (size: any) => {
    setIsClickSizeCheckList(true);
    let gaSizeArr: any = selectedTags.filterSizes.map((item) => item.name);
    const index = selectedSizes.findIndex(
      (selectedSize) => selectedSize.code === size.code
    );
    if (index === -1) {
      gaSizeArr.push(size.name);
      // 选择的tag 添加一个size tag
      onChangeSelectedSizes([...selectedSizes, size]);
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize) => filteredSize.code === size.code
      );
      // 勾选size
      if (sizeIndex > -1) {
        const newSizes = filteredSizes;
        newSizes[sizeIndex].checked = true;
        setFilteredSizes([...newSizes]);
      }
    } else {
      // 点击取消 删除选择的size tag
      const newSizes = selectedSizes;
      newSizes.splice(index, 1);
      gaSizeArr = newSizes.map((item) => item.name);
      onChangeSelectedSizes([...newSizes]);
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize) => filteredSize.code === size.code
      );
      // 点击取消 取消size勾选状态
      if (sizeIndex > -1) {
        const newFilteredSizes = filteredSizes;
        newFilteredSizes[sizeIndex].checked = false;
        setFilteredSizes([...newFilteredSizes]);
      }
    }
    const sizesForGa = gaSizeArr.join(",");
    const catAndGenArr = selectedTags.filtercategories.map((item) => item.name);
    const genderForGa = catAndGenArr[0] || null;
    const categoryForGa = catAndGenArr.slice(1).join(",") || null;
    sendTrackEvent({
      brand: transformBrandForGoogleAnalytics(config.brand_name),
      event: TRACK_EVENT_SEARCH,
      eventAction: "ImageItemSearch",
      eventCategory: "IS_Item_Filter",
      eventLabel: `${[...catAndGenArr, ...gaSizeArr].join(",")}`,
      genderFilter: genderForGa,
      categoryFilter: categoryForGa,
      sizeFilter: sizesForGa
    });
  };
  const updateSizesStatus = () => {
    const newSizes = JSON.parse(JSON.stringify([...sizes]));
    selectedSizes.forEach((selectedSize: any) => {
      const searchCodeIndex = newSizes.findIndex(
        (size: any) => size.code === selectedSize.code
      );
      if (searchCodeIndex > -1) {
        newSizes[searchCodeIndex].checked = true;
      }
    });
    setFilteredSizes(newSizes);
  };
  const updateSearchCategoriesStatus = () => {
    let newCategories = [];
    if (tree[categoryType] && tree[categoryType].length) {
      newCategories = tree[categoryType].map((item: any) => ({
        ...item,
        categoryType: categoryType
      }));
    }
    setFilteredCategories(newCategories);
  };

  // 刷新页面的时候重新初始化
  useEffect(() => {
    updateSearchCategoriesStatus();
    updateSizesStatus();
  }, [sizes, tree]);
  useEffect(() => {
    updateSizesStatus();
  }, [categoryType]);

  const getGenderOptions = () => {
    if (!isEmpty(tree)) {
      return tree.genders.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  const getClassOptions = () => {
    if (!isEmpty(tree)) {
      return tree.classes.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  const getCategoryOptions = () => {
    if (!isEmpty(tree)) {
      return tree.categories.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  const getSubcategoryOptions = () => {
    if (!isEmpty(tree)) {
      return tree.subcategories.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  useEffect(() => {
    if (
      (categoryType === "genders" ||
        categoryType === "classes" ||
        categoryType === "categories" ||
        categoryType === "subcategories" ||
        categoryType === "") &&
      getGenderOptions().length !== 0
    ) {
      setIsShowGenderSelect(true);
    } else {
      setIsShowGenderSelect(false);
    }
    if (
      (categoryType === "genders" ||
        categoryType === "classes" ||
        categoryType === "categories" ||
        categoryType === "subcategories" ||
        categoryType === "") &&
      getClassOptions().length !== 0
    ) {
      setIsShowClassSelect(true);
    } else {
      setIsShowClassSelect(false);
    }
    if (
      (categoryType === "categories" ||
        categoryType === "subcategories" ||
        categoryType === "") &&
      getCategoryOptions().length !== 0
    ) {
      setIsShowCategorySelect(true);
    } else {
      setIsShowCategorySelect(false);
    }
    if (
      (categoryType === "subcategories" || categoryType === "") &&
      getSubcategoryOptions().length !== 0
    ) {
      setIsShowSubcategorySelect(true);
    } else {
      setIsShowSubcategorySelect(false);
    }
  }, [categoryType, tree]);

  return (
    <CollectionList>
      {(selectedTags.filtercategories.length > 0 ||
        selectedTags.filterSizes.length > 0) && (
        <>
          <Spacer element="div" variant={"spacing-04"} />
          <Title element="p" className="fr-ec-mb-spacing-04">
            {t("text_active_filters")}
          </Title>
          <TagFilterGroup
            clearLabel={t("text_image_search_clear_all_filters")}
            onClear={handlerClearAllFilter}
            ecRenewal={getEcRenewalCompatibility()}
          >
            {selectedTags.filtercategories.map((category: any) => (
              <TagFilter
                disabled={false}
                value={category.name}
                key={category.id}
                onClick={() => {
                  handlerDeleteTag(category);
                }}
              />
            ))}
            {selectedTags.filterSizes.map((size: any) => (
              <TagFilter
                disabled={false}
                value={size.name}
                key={size.code}
                onClick={() => {
                  handlerDeleteTag(size);
                }}
              />
            ))}
          </TagFilterGroup>
        </>
      )}
      <Spacer element="div" variant={"spacing-05"} />
      <Accordion
        disabled={false}
        element="div"
        id="accordion-id"
        label={t("text_search_filter_gender_and_category")}
        labelChildren=""
        labelElement="h5"
        onClose={handlerCategoryExpand}
        onExpand={handlerCategoryExpand}
        variant="dynamic"
        expanded={visibleCategory}
      >
        <Spacer element="div" variant="spacing-04" />
        {isShowGenderSelect && (
          <Dropdown
            id="selectGender"
            name="genderOptions"
            className="fr-ec-mb-spacing-06"
            label={t("text_gender")}
            placeholder={t("text_all")}
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "genders"
              );
            }}
            isNative
            value={
              props.searchCategories[0]
                ? JSON.parse(props.searchCategories[0])
                : undefined
            }
            options={getGenderOptions()}
            disabled={false}
          />
        )}
        {isShowClassSelect && (
          <Dropdown
            id="selectClass"
            name="classOptions"
            className="fr-ec-mb-spacing-05"
            label={t("text_category")}
            placeholder={
              categoryType === "genders"
                ? t("text_search_filter_select_category_message_01")
                : t("text_all")
            }
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "classes"
              );
            }}
            isNative
            value={
              props.searchCategories[1]
                ? JSON.parse(props.searchCategories[1])
                : undefined
            }
            options={getClassOptions()}
            disabled={categoryType === "genders"}
          />
        )}
        {isShowCategorySelect && (
          <Dropdown
            id="selectCategory"
            name="categoryOptions"
            className="fr-ec-mb-spacing-05"
            placeholder={t("text_all")}
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "categories"
              );
            }}
            isNative
            value={
              props.searchCategories[2]
                ? JSON.parse(props.searchCategories[2])
                : undefined
            }
            options={getCategoryOptions()}
            disabled={false}
          />
        )}
        {isShowSubcategorySelect && (
          <Dropdown
            id="selectSubcategory"
            name="subcategoryOptions"
            className="fr-ec-mb-spacing-05"
            placeholder={t("text_all")}
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "subcategories"
              );
            }}
            isNative
            value={
              props.searchCategories[3]
                ? JSON.parse(props.searchCategories[3])
                : undefined
            }
            options={getSubcategoryOptions()}
            disabled={false}
          />
        )}
        <Spacer element="div" variant="spacing-04" />
      </Accordion>
      <Accordion
        disabled={false}
        element="div"
        id="accordion-id"
        label={t("text_size")}
        labelChildren=""
        labelElement="h5"
        onClose={handlerSizeExpand}
        onExpand={handlerSizeExpand}
        variant="dynamic"
        expanded={visibleSize}
      >
        {filteredSizes.length > 0 ? (
          <CheckboxGroup
            error=""
            hint=""
            id="Checkbox-color-17"
            required={false}
            columnCount={
              isEmptyList ? emptyListColumnCount : nonEmptyListColumnCount
            }
          >
            {filteredSizes.map((size: any) => (
              <Checkbox
                checked={!!size.checked}
                id={`${size.code}-FilterDetail`}
                key={`${size.code}-FilterDetail`}
                label={size.name}
                name={size.name}
                onChange={() => {
                  handlerSizeClick(size);
                }}
                value={size.code}
              />
            ))}
          </CheckboxGroup>
        ) : (
          <Body element="p" variant="standard">
            {t("text_search_filter_unavailable_size_option")}
          </Body>
        )}
        <Spacer element="div" variant="spacing-04" />
      </Accordion>
    </CollectionList>
  );
};

export default ProductTabFilterDetails;
